import admin from "./locales/en/admin.json";
import auth from "./locales/en/auth.json";
import billing from "./locales/en/billing.json";
import common from "./locales/en/common.json";
import device from "./locales/en/device.json";
import errors from "./locales/en/errors.json";
import menu from "./locales/en/menu.json";
import nav from "./locales/en/nav.json";
import offers from "./locales/en/offers.json";
import orders from "./locales/en/orders.json";
import printing from "./locales/en/printing.json";
import reports from "./locales/en/reports.json";
import staff from "./locales/en/staff.json";
import storefront from "./locales/en/storefront.json";

/** English is the source language. Other languages must have the same keys. */
export const en = {
	common,
	auth,
	nav,
	errors,
	admin,
	staff,
	menu,
	orders,
	billing,
	printing,
	offers,
	storefront,
	reports,
	device,
} as const;

export type Namespace = keyof typeof en;
export const namespaces = Object.keys(en) as Namespace[];

export const SUPPORTED_LANGUAGES = ["en"] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: Language = "en";

export const resources: Record<Language, typeof en> = { en };
